// extracted by mini-css-extract-plugin
module.exports = {"WeekendHeader":"WeekendHeader_WeekendHeader__F5uJJ","logo":"WeekendHeader_logo__zJYrt","newsletter":"WeekendHeader_newsletter__9x1lM"};